import loadable from '@/utils/loadable';
import LoadingIndicator from '@/utils/LoadingIndicator';

export default loadable(() => import('./LicenceAreaImpactComparison'), {
  fallback: <LoadingIndicator />,
});
